/* eslint-disable array-callback-return */
import * as React from 'react';
import MenuPayrollIncidents from "../components/MenuPayrollIncidents";
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import SquareIcon from '@mui/icons-material/Square';
import SendIcono from "../../../assets/svg/SendIcono.svg";
import IconoCheck from "../../../assets/svg/IconoCheck.svg";
import DoubleCheck from "../../../assets/svg/DoubleCheck.svg";
import moment from "moment";
import { formatterMxn } from "../../../helpers/formatoMoneda";


interface Data {
    id: number;
    Tipo: string;
    FechaGenerado: string;
    FechaFin: string;
    Total: number;
    Dias: number;
    horas:number
    Colaborador: string;
    TipoCobro: string;
    AreaProyecto: string;
    Sede: string;
    TipoConcepto: string;
    email:string;
    Comentarios: string;
    ApprovedRH: number;
    ApprovedDirect: number;
    ConceptName:string;
    idAdelanto: number;
  }
  
  function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
    const aVal = a[orderBy];
    const bVal = b[orderBy];
    if (typeof bVal === 'string' && typeof aVal === 'string') {
      return bVal.localeCompare(aVal, 'es', { sensitivity: 'base' });
    }
    if (bVal < aVal) return -1;
    if (bVal > aVal) return 1;
    return 0;
  }
  
  type Order = 'asc' | 'desc';
  
  function getComparator<Key extends keyof any>(
    order: Order,
    orderBy: Key,
  ): (
    a: { [key in Key]: number | string },
    b: { [key in Key]: number | string },
  ) => number {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  } 

  function stableSort<T>(array: readonly T[], comparator: (a: T, b: T) => number) {
    const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  
  interface HeadCell {
    disablePadding: boolean;
    id:  keyof Data;
    label: string;    
  }
  
  const headCells: readonly HeadCell[] = [
    {
      id: 'Colaborador',      
      disablePadding: true,
      label: 'Nombre de colaborador',
    },
    {
      id: 'Sede',    
      disablePadding: false,
      label: 'Sede',
    },
    {
      id: 'AreaProyecto',       
      disablePadding: false,
      label: 'Área o proyecto',
    },
    {
      id: 'TipoConcepto',    
      disablePadding: false,
      label: 'Categoría',
    },
    {
      id: 'Comentarios',   
      disablePadding: false,
      label: 'Concepto',
    },
    {
      id: 'FechaGenerado',    
      disablePadding: false,
      label: 'Fechas',
    },
    {
      id: 'Total',    
      disablePadding: false,
      label: 'Cantidad',
    },
    {
      id: 'TipoCobro',    
      disablePadding: false,
      label: 'Unidad',
    },
    {
      id: 'ApprovedRH',    
      disablePadding: false,
      label: 'Estatus',
    },
    {
      id: 'Colaborador',       
      disablePadding: false,
      label: 'Opciones',
    } 
  ];
  
  interface EnhancedTableProps {
    numSelected: number;
    onRequestSort: (event: React.MouseEvent<unknown>, property: keyof Data) => void;
    onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
    order: Order;
    orderBy: string;
    rowCount: number;
  }
  
  function EnhancedTableHead(props: EnhancedTableProps) {  
    const { onSelectAllClick, order, orderBy, numSelected,
        rowCount,
        onRequestSort } =
      props;
    const createSortHandler =
      (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
        onRequestSort(event, property);
      };
  
    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox"  className="tableHeader">
            <Checkbox
             checkedIcon={
                    <SquareIcon sx={{  
                               background: 'radial-gradient(#979797 10px 100%,  #ffffff 100%)',
                               color: "#fabb00", 
                               stroke: "#ffffff",
                              strokeWidth: 2 
                                                  }}
                                                    />
                    }
              indeterminateIcon={
                <SquareIcon sx={{  
                  background: 'radial-gradient(#979797 10px 100%,  #ffffff 100%)',
                  color: "#fabb00", 
                  stroke: "#ffffff",
                  strokeWidth: 2 
                                    }}
                                     />
              }
              sx={{
                color: "#979797",             
            }}  
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{
                'aria-label': 'Seleccionar todas las incidencias',
              }}
            />    
          </TableCell>
           {headCells.map((headCell) => (
            <TableCell
              className="tableHeader"
              key={headCell.id}                   
              padding={headCell.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
               <TableSortLabel
                active={orderBy === headCell.id}
                 direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
                className="labelHeader"
              >
                {headCell.label}             
              </TableSortLabel>
            </TableCell>
          ))} 
        </TableRow>
      </TableHead>
    );
  }

const TablePayRollIncident = ({rows,setArrayIncident,selected,setSelected,page,setPage}:any) => {
    const [order, setOrder] = React.useState<Order>("desc");
    const [orderBy, setOrderBy] = React.useState<keyof Data>("FechaGenerado");  
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
   
    const handleRequestSort = (
      event: React.MouseEvent<unknown>,
      property: keyof Data
    ) => {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    };
  
    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.checked) {
         let newSelected = rows.map((n:any) => {        
            if(n.ApprovedDirect && !n.ApprovedRH){
              return n.id
            }       
         });                
        setSelected(newSelected);
        setArrayIncident(newSelected)
        return;
      }      
      setSelected([]);
      setArrayIncident([]);
    };  

    const handleClick = (event: React.MouseEvent<unknown>, id: number) => {
      const selectedIndex = selected.indexOf(id);
      let newSelected: readonly number[] = [];
  
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, id);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selected.slice(0, selectedIndex),
          selected.slice(selectedIndex + 1)
        );
      }
      setSelected(newSelected);
      setArrayIncident(newSelected)
    };
  
    const handleChangePage = (event: unknown, newPage: number) => {      
      setPage(newPage);
    };

  
    const handleChangeRowsPerPage = (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
  
    const isSelected = (id: number) => selected.indexOf(id) !== -1;
  
    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;    
    
    const visibleRows = React.useMemo(
      () =>
        stableSort(rows, getComparator(order, orderBy)).slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage
        ),
      [order, orderBy, page, rows, rowsPerPage]
    );
  
    return (
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%"}}>
          <TableContainer>
            <Table
              sx={{ minWidth: 600 }}
              aria-labelledby="tableTitle"             
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
              />
              <TableBody>
                {visibleRows.map((row, index) => {
                  const castId=Number(row.id)
                  const isItemSelected = isSelected(castId);
                  const labelId = `enhanced-table-checkbox-${index}`;  
                  return (
                    <TableRow             
                      hover                              
                      tabIndex={-1}
                      key={row.id}      
                      sx={{ cursor: "pointer" }}                
                    >
                      <TableCell padding="checkbox">
                      {row.ApprovedDirect && !row.ApprovedRH  &&(
                        <Checkbox
                          onClick={(event) => handleClick(event, castId)}
                          checked={isItemSelected}                        
                          inputProps={{
                            "aria-labelledby": labelId,
                          }}
                          checkedIcon={
                            <SquareIcon sx={{  
                              background: 'radial-gradient(#979797 10px 100%,  #ffffff 100%)',
                              color: "#fabb00", 
                              stroke: "#ffffff",
                             strokeWidth: 2 
                              }}
                            />
                          }
                           sx={{ color: "#979797", }}                                                   
                        />                  
                        )}
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="none"                       
                      >
                       <div className="containerTwo">
                          <div className="containerInfoName"> {row.Colaborador} </div>
                          <div className="containerInfoEmail"> {row.email}  </div>      
                       </div>                     
                      </TableCell>
                      <TableCell align="left">{row.Sede}</TableCell>
                      <TableCell align="left">{row.AreaProyecto}</TableCell>
                      <TableCell align="left">{row.TipoConcepto}</TableCell>
                      <TableCell align="left">{row.ConceptName}</TableCell>
                      <TableCell align="left" ><div className='datesIncidentPayRoll'><span className='datePayRoll'>{`${moment(row.FechaGenerado).utc().format('DD/MM/yyyy')} - 
                                                ${moment(row.FechaFin).utc().format('DD/MM/yyyy')}`}</span> </div>
                                            </TableCell>                                         
                      {row.Tipo ==='Dinero'?
                      <TableCell align="left"  >
                         <div className='menuPayrollIncidents'>{row.Total ===0 ? '$0.00': formatterMxn(row.Total)} </div>   </TableCell>:
                      Number(row.horas) > 0 ?
                      <TableCell align="left"  >                        
                        <div className='menuPayrollIncidents'>                           
                           { `${row.horas} ` }{ row.horas !== 1 ? 'horas':'hora'}
                        </div>   </TableCell>
                      :
                      <TableCell align="left"  >                        
                        <div className='menuPayrollIncidents'>                           
                           { `${row.Dias} ` }{ row.Dias !== 1 ? 'días':'día'}
                        </div>   </TableCell>
                      }
                      
                      <TableCell align="left" ><div className='tipoPayrollIncidents'>{row.Tipo}</div></TableCell>
                     { !row.ApprovedDirect && !row.ApprovedRH ?
                         <TableCell align="center" >
                          <div className='menuPayrollIncidents'>
                            <img  src={SendIcono} alt=""></img>
                            </div>
                         </TableCell>
                      : row.ApprovedDirect && !row.ApprovedRH ?
                          <TableCell align="center" >
                            <img  src={IconoCheck} alt=""></img>
                          </TableCell>
                      :
                          <TableCell align="center" >
                            <img  src={DoubleCheck}  alt=""></img>
                          </TableCell>
                      } 
                     <TableCell align="center" >
                     
                       <MenuPayrollIncidents 
                             idPayRoll={row.id}
                             infoRow={row}
                              />                          
                     </TableCell>
                    </TableRow>
                  );
                })} 
                {emptyRows > 0 && (
                  <TableRow>
                    <TableCell colSpan={11} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage='Número de registros'    
          />
        </Paper>        
      </Box>
    );
}

export default TablePayRollIncident

